module.exports = __webpack_public_path__ + "static/img/12bg_7.f6382d1.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/12bg_7.png
// module id = 637
// module chunks = 1